export default __webpack_public_path__ + "static/media/mon_256.452f49ac.png";